import React, { useRef, useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import FormModal from '../../components/Modals/FormModal';
import ShareProfileForm from '../../components/Forms/ShareProfileForm/ShareProfileForm'
import CompletenessScoreInfo from '../../components/Forms/CompletenessScoreInfo/CompletenessScoreInfo'
import ProfessionalProfile from '../../components/ProfessionalProfile/ProfessionalProfile';
import RightPanel from '../../components/ProfessionalProfile/RightPanel/RightPanel';
import styles from './AdvisorProfile.module.scss';
import advisorProfileService from '../../services/advisorProfile.service';
import consumerProfileService from '../../services/consumerProfile.service';
import { UserContext } from '../../Utils/UserContext';
import Button from '../../components/Button/Button'
import { User, PhoneCall, Settings, Eye, Edit2, Share, Shield, HelpCircle } from 'react-feather';
import { useNavigate } from 'react-router';
import { Context } from '../../Utils/GlobalStore/Store';
import ClipLoader from "react-spinners/ClipLoader";
import SEO from '../../components/SEO/seo';
import GlobalFooter from '../../components/GlobalFooter/GlobalFooter'
import useMixPanelEvent from "../../Utils/MixPanel";
import { advisorFinderDisclosure } from "../../constants/disclosure";
import RSNIPDisclosureText from "../../components/RSNIPDisclosureText/RSNIPDisclosureText";
import ScheduleCallNoUserForm from "../../components/Forms/ScheduleCallNoUserForm/ScheduleCallNoUserForm";
import { generateAdvisorSchema } from "../../components/SEO/seoUtils";

function AdvisorProfle() {

    const mixpanelTrack = useMixPanelEvent();

    const { user } = useContext(UserContext);
    const [state, dispatch] = useContext(Context);
    const navigate = useNavigate();


    let { professionalId } = useParams()
    const [editMode, setEditMode] = useState(false);
    const [advisor, setAdvisor] = useState({});
    const [isDesktop, setDesktop] = useState(window.innerWidth > 1040);
    const [loading, setLoading] = useState(true);
    const [myProfile, setMyProfile] = useState(false);
    const [showShareProfileModal, setShowShareProfileModal] = useState(false);
    const [showScheduleCallModal, setShowScheduleCallModal] = useState(false);
    const [completenessScore, setCompletenessScore] = useState(advisor.profileCompletenessScore);
    const [completenessStyle, setCompletenessStyle] = useState({ width: `${advisor.profileCompletenessScore ?? 0}%` })
    const [showCompletenessScoreModal, setShowCompletenessScoreModal] = useState(false);
    const [firmAdminAuth, setFirmAdminAuth] = useState(false);
    const [advisorSchema, setAdvisorSchema] = useState({})

    const isConsumer = JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).groups.includes('Consumer') : false;
    const isFirmAdmin = JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).groups.includes('FirmAdmin') : false;

    const buttonRef = useRef(null);

    useEffect(async () => {
        setLoading(true)
        const advisorResponse = await getAdvisorInfo();
        setAdvisorSchema(generateAdvisorSchema(advisorResponse));
        mixpanelTrack('Profile View', 'Advisor', `${advisorResponse.firstName} ${advisorResponse.lastName}`);
        setLoading(false);
        await getSpecaltyOptions();
        if (isConsumer) {
            const consumer = JSON.parse(localStorage.getItem('user'))
            const myInit = {
                body: {
                    consumerId: consumer.id,
                    professionalId: advisorResponse.professionalId
                }
            };

            try {
                await consumerProfileService.createLead(myInit);
            } catch (error) {
                console.error(error);
            }
        }
        else if (isFirmAdmin) {
            console.log(user);
            console.log(advisorResponse)
            if (advisorResponse.firmId === user.firmID) {
                setFirmAdminAuth(true);
            }
        }

        window.addEventListener("resize", updateMedia);

        return () => window.removeEventListener("resize", updateMedia);
    }, [professionalId]);

    useEffect(async () => {
        if (JSON.parse(localStorage.getItem('user')) && JSON.parse(localStorage.getItem('user')).userName === advisor.cognitoUsername || firmAdminAuth) {
            setMyProfile(true)
        } else {
            setMyProfile(false);
            setEditMode(false);
        }
    }, [advisor, firmAdminAuth])

    const updateMedia = () => {
        setDesktop(window.innerWidth > 1040);
    };

    const scheduleCall = () => {
        mixpanelTrack('Schedule Call Button Clicked', 'Advisor', `${advisor.firstName} ${advisor.lastName}`);
        setShowScheduleCallModal(true)
    }

    function movePurle(mode) {
        setEditMode(mode);
        if (mode) {
            buttonRef.current.style.transform = `translate3d(100%, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)`;
        } else {
            buttonRef.current.style.transform = `translate3d(0%, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)`;
        }
    }

    async function getAdvisorInfo() {
        try {
            const advisorResponse = await advisorProfileService.getOne(professionalId);
            if ((!advisorResponse.accountEnabled || !advisorResponse.hasLoggedIn) && !user.groups.includes("Admin")) {
                if (!isFirmAdmin || advisorResponse.firmId !== user.firmID) {
                    navigate(`/404`, { replace: true });
                }
            }
            setAdvisor(advisorResponse);
            setCompletenessScore(advisorResponse.profileCompletenessScore);
            setCompletenessStyle({ width: `${advisorResponse.profileCompletenessScore ?? 0}%` })
            return advisorResponse;
        } catch (error) {
            console.log(error);
            // error state
            navigate(`/404`, { replace: true });
        }
    }

    async function getSpecaltyOptions() {
        if (state.specialties.length <= 0) {
            const specialtyResponse = await advisorProfileService.getSpecialties();
            dispatch({ type: 'SET_SPECIALTIES', payload: specialtyResponse.specialities.sort((a, b) => a.displayOrder - b.displayOrder) });
        }
        if (state.clientele.length <= 0) {
            const clienteleResponse = await advisorProfileService.getClientele();
            dispatch({ type: 'SET_CLIENTELE', payload: clienteleResponse.clientele.sort((a, b) => a.displayOrder - b.displayOrder) });
        }
        if (state.pricing.length <= 0) {
            const pricingResponse = await advisorProfileService.getPricing();
            dispatch({ type: 'SET_PRICING', payload: pricingResponse.pricing });
        }
        if (state.services.length <= 0) {
            const servicesResponse = await advisorProfileService.getServices();
            dispatch({ type: 'SET_SERVICES', payload: servicesResponse.services.sort((a, b) => a.displayOrder - b.displayOrder) });
        }
        if (state.assetRanges.length <= 0) {
            const assetRangeResponse = await advisorProfileService.getAssetRanges();
            dispatch({ type: 'SET_ASSETRANGES', payload: assetRangeResponse.assetRanges });
        }
        if (state.credentials.length <= 0) {
            const credentials = await advisorProfileService.getCredentials();
            dispatch({ type: 'SET_CREDENTIALS', payload: credentials.credentials });
        }
    }

    function showScheduleCallButton() {
        if (!(advisor.calendlyUser || advisor.calendlyUrl) && !advisor.phoneNumber) {
            return false;
        } else if (isConsumer || !user) {
            return true;
        }
        return false;
    }

    function handleShareProfile() {
        setShowShareProfileModal(true)
        mixpanelTrack(`Advisor: ${advisor.firstName} ${advisor.lastName} - ${advisor.email}`, 'Event Type', 'Share Button Clicked');
    }


    return (
        <>
            {loading && <div className='spinnerContainer'>
                <ClipLoader color={'var(--adfi_blue500)'} loading={loading} size={100} />
            </div>}

            {Object.keys(advisor).length !== 0 && !loading &&
                <SEO
                    title={`${advisor.firstName} ${advisor.lastName} | Financial Advisor | ${advisor.city}, ${advisor.state}`}
                    description={`Meet ${advisor.firstName} ${advisor.lastName}, a financial advisor in ${advisor.city}, ${advisor.state}. View their services, specialties, education, and pricing on AdvisorFinder. Schedule a call with ${advisor.firstName} today.`}
                    name='AdvisorFinder'
                    type='profile'
                    canonical={`https://app.advisorfinder.com/advisor-profile/${advisor.professionalId}/${advisor.firstName}-${advisor.lastName}/`}
                    schema={advisorSchema}
                />
            }

            {Object.keys(advisor).length !== 0 && !loading && <div className={`${styles.pageContainer} ${styles.sideNavMargin}`}>
                {showShareProfileModal && <FormModal onClose={() => setShowShareProfileModal(false)} show={showShareProfileModal}>
                    <ShareProfileForm advisor={advisor}></ShareProfileForm>
                </FormModal>}
                {showCompletenessScoreModal && <FormModal onClose={() => setShowCompletenessScoreModal(false)} show={showCompletenessScoreModal} title="Profile Completeness Score">
                    <CompletenessScoreInfo></CompletenessScoreInfo>
                </FormModal>}
                {showScheduleCallModal && <FormModal onClose={() => setShowScheduleCallModal(false)} show={showScheduleCallModal} noPadding={true}>
                    <ScheduleCallNoUserForm advisor={advisor}></ScheduleCallNoUserForm>
                </FormModal>}
                {myProfile &&
                    <>
                        <div className={styles.profileHeader}>
                            {isDesktop && <div className={styles.iconContainer}><User size={24} color={'var(--adfi_blue500)'} /></div>}
                            {isDesktop && <h1 className={styles.profileHeaderText}>{firmAdminAuth ? `${advisor.firstName} ${advisor.lastName}'s Profile` : `My Profile`}</h1>}
                            <div className={styles.toggleWrapper}>
                                <div className={styles.profileToggle}>
                                    <div ref={buttonRef} className={styles.togglePurple}></div>
                                    <div className={`${styles.toggleText} ${editMode ? styles.toggleTextHover : ''}`} style={{ color: !editMode ? '#fff' : 'var(--adfi_blue500)' }} onClick={() => movePurle(false)}>
                                        {isDesktop ? <div>Preview</div> : <Eye size={20}></Eye>}
                                    </div>
                                    <div className={`${styles.toggleText} ${!editMode ? styles.toggleTextHover : ''}`} style={{ color: !editMode ? 'var(--adfi_blue500)' : '#fff' }} onClick={() => movePurle(true)}>
                                        {isDesktop ? <div>Edit View</div> : <Edit2 size={20}></Edit2>}
                                    </div>
                                </div>
                            </div>
                            <div className={styles.rightSideButtons}>
                                <Button color="clear-button white" onClick={() => handleShareProfile()}><Share size={20} /></Button>
                                <Button color="gradient-button" onClick={() => navigate('/account-settings')}><Settings size={20} />{isDesktop && <>Settings</>}</Button>
                            </div>
                        </div>
                        {editMode && <div className={styles.editDisclosure}><Shield />By making any updates to your profile, you certify that it has been approved by the necessary compliance personnel at your firm.
                        </div>}
                        {completenessScore && <div className={styles.completenessScoreContainer}>
                            <div className={styles.mobileContainer}>
                                <div className={styles.mobileContainerText}>
                                    <span className={styles.completenessScoreNumber}>{completenessScore}%</span>
                                    <span className={styles.completenessScoreText}>Profile completeness</span>
                                </div>
                                <div className={styles.progressBarContainer}>
                                    <div className={styles.progressBar} style={completenessStyle}></div>
                                </div>
                            </div>
                            <div className={styles.howItWorksContainer} onClick={() => setShowCompletenessScoreModal(true)}>
                                <HelpCircle size={16} />
                                <div>How It works?</div>
                            </div>
                        </div>}
                    </>
                }
                {!myProfile &&
                    <h1 className={styles.profileHeader}>
                        {isDesktop && <div className={styles.iconContainer}><User size={24} color={'var(--adfi_blue500)'} /></div>}
                        <div className={styles.profileHeaderText}>{advisor.firstName} {advisor.lastName} | Financial Advisor</div>
                        <div className={styles.rightSideButtons}>
                            <Button color="clear-button white" onClick={() => handleShareProfile()}><Share size={20} /></Button>
                            {showScheduleCallButton() && (<Button color="gradient-button" onClick={() => scheduleCall()}><PhoneCall size={20} />{isDesktop && <>Schedule a call</>}</Button>)}
                        </div>
                    </h1>
                }
                <div className={styles.profileContainer}>
                    <ProfessionalProfile advisor={advisor} setAdvisor={setAdvisor} editMode={editMode} setCompletenessStyle={setCompletenessStyle} setCompletenessScore={setCompletenessScore} firmAdminAuth={firmAdminAuth}></ProfessionalProfile>
                    <RightPanel advisor={advisor} editMode={editMode} setCompletenessStyle={setCompletenessStyle} setCompletenessScore={setCompletenessScore} firmAdminAuth={firmAdminAuth}></RightPanel>
                </div>
                <div className={`${styles.sideNavMargin} ${styles.disclosureContainer}`}>
                    <span className={styles.disclosureHeader}>AdvisorFinder Disclosure</span>
                    <div className={styles.disclosureText}>{advisorFinderDisclosure}</div>
                </div>
                {advisor.disclosureText &&
                    <div className={`${styles.sideNavMargin} ${styles.disclosureContainer}`}>
                        <span className={styles.disclosureHeader}>Advisor Disclosure</span>
                        <div className={styles.disclosureText}>
                            {advisor.disclosureText}
                            {advisor.finraMember && <> Member <a href="https://www.finra.org/#/" target="_blank" rel="noreferrer">FINRA</a>/<a href="https://www.sipc.org/" target="_blank" rel="noreferrer">SIPC</a>.</>}
                        </div>
                    </div>
                }
                {advisor.rsnipDisclosure &&
                    <div className={styles.rsnipDisclosureContainer}>
                        <RSNIPDisclosureText />
                    </div>
                }
            </div>
            }
            {!loading && <GlobalFooter background={true} />}
        </>
    )

}

export default AdvisorProfle;